module.exports = __webpack_public_path__ + "img/applod.92b124c4.png";